import React                                  from 'react'
import { FormGroup, FormControl, InputGroup,
         HelpBlock, Glyphicon } from 'react-bootstrap'
import ButtonInputAddon                       from './button_input_addon'

export SaveInputAddon = ({ id, className = '', isSaved, isValid, onSave }) ->
  glyph =
    if isSaved then 'floppy-saved'
    else if isValid then 'floppy-save'
    else 'floppy-remove'

  <ButtonInputAddon id={id} className={className} onClick={onSave}
                    disabled={isSaved or not isValid}>
    <Glyphicon glyph={glyph} />
  </ButtonInputAddon>

export SaveInputGroup = ({ id, className, type = 'text', value,
                           isSaved, isValid, onChange, onSave }) ->
  <InputGroup id={id} className={className}>
    <FormControl type={type} value={value}
                 onChange={(e) -> onChange(e.target.value)} />
    <SaveInputAddon isSaved={isSaved} isValid={isValid} onSave={onSave} />
  </InputGroup>

export default SaveInput = ({ id, className, type = 'text', value, help,
                              isValid, isSaved, onChange, onSave }) ->
  validationState =
    if isSaved then null
    else if isValid then 'success'
    else 'error'

  <FormGroup id={id} className={className} validationState={validationState}>
    <SaveInputGroup type={type} value={value} help={help}
                    isValid={isValid} isSaved={isSaved}
                    onChange={onChange} onSave={onSave} />
    {<HelpBlock>{help}</HelpBlock> if help}
  </FormGroup>
